import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet, RouterModule } from '@angular/router';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';

import {  FuseNavigationItem, FuseNavigationService, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { Navigation } from 'app/core/navigation/navigation.types';


import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';


import { ShortcutsComponent } from 'app/layout/common/shortcuts/shortcuts.component';
import { UserComponent } from 'app/layout/common/user/user.component';
import { Subject, takeUntil } from 'rxjs';
import { Auth, signInAnonymously } from '@angular/fire/auth';
import { LoaderComponent } from '../../../../modules/loader/loader.component';
import { CommonService } from '../../../../Common/common.service';
import { environment } from '../../../../../environments/environment';
import * as moment from 'moment';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';





@Component({
  selector: 'classic-layout',
  templateUrl: './classic.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ LoaderComponent, FuseVerticalNavigationComponent, MatButtonModule, MatIconModule, FuseFullscreenComponent, ShortcutsComponent,NotificationsComponent, UserComponent, NgIf, RouterOutlet, RouterModule, MatTooltipModule, TranslatePipe],
}) 
export class ClassicLayoutComponent implements OnInit, OnDestroy {
  offer_days_left = "0 Day";
  show_offer = false;
  show_offer_button = false;
  yearly_offer_button = false;
  pending_invoice = false;
  offer_text = "";
  offer_code = "";
  role_permissions: any;
  type: number = 0;
  ges_system: boolean = false;
  isScreenSmall: boolean;
  navigation: Navigation;
  dialogRef: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  navigation_appearance = 'default';

  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,

    private _navigationService: NavigationService,
    private _fuseMediaWatcherService: FuseMediaWatcherService,
    private _fuseNavigationService: FuseNavigationService,
    private afAuth: Auth,
    private _commonService: CommonService,
    public _matDialog: MatDialog,
  ) {


    signInAnonymously(this.afAuth)
      .then((user) => {
        console.log("signed In")
      })
      .catch((error) => {
        console.log(error)
      });

    this.afAuth.onAuthStateChanged(function (user) {
      if (user) {
        // User is signed in
        console.log("signed In already uid: " + user.uid);
        // ...
      } else {

        signInAnonymously(this.afAuth)
          .then((user) => {
            console.log("signed In")
          })
          .catch((error) => {
            console.log(error)
          });

      }
    });


  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((navigation: Navigation) => {
        this.navigation = navigation;
        this.syncNavigationForAppearance({ refresh: this.navigation_appearance === 'thin' });

      });

    // Subscribe to media changes
    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });

    this.ges_system = environment.ges_system;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    if (this.isScreenSmall) {

      const navigation = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>(name);

      if (navigation) {
        // Toggle the opened status
        navigation.toggle();
      }

    }
    else {
      this.navigation_appearance =
        this.navigation_appearance === 'thin'
          ? 'default'
          : 'thin';
      this.syncNavigationForAppearance({ refresh: true, closeAside: true });
    }
  }

  private syncNavigationForAppearance(options: { refresh?: boolean; closeAside?: boolean } = {}): void {
    if (!this.navigation?.default) {
      return;
    }

    this.navigation.default.forEach(item => {
      if (this.navigation_appearance === 'thin') {
        item.tooltip = item.title;
        if (item.type === 'collapsable') {
          item.type = 'aside';
        }
      }
      else {
        item.tooltip = '';
        if (item.type === 'aside') {
          // Keep Reports collapsable whenever it has submenu items (e.g. All Reports)
          if (item.id === 'reports' && (!item.children || item.children.length === 0)) {
            item.type = 'basic';
            item.link = '/reports';
          }
          else {
            item.type = 'collapsable';
          }
        }
      }
    });

    if (options.refresh || options.closeAside) {
      const navComponent = this._fuseNavigationService.getComponent<FuseVerticalNavigationComponent>('mainNavigation');
      if (navComponent) {
        if (options.closeAside) {
          navComponent.closeAside();
        }
        if (options.refresh) {
          navComponent.refresh();
        }
      }
    }
  }

}
